import React from "react";
import { useAuth } from "@/lib/auth";
import { AlertTriangle } from "lucide-react";

/** Persistent banner shown on every page while the user is in demo mode. */
export default function DemoBanner() {
  const { user } = useAuth();
  if (!user || user.role !== "demo") return null;
  return (
    <div data-testid="demo-banner"
      className="bg-[#FEF3C7] border-b border-[#FCD34D] text-[#92400E] text-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span className="font-semibold tracking-wide uppercase text-xs">Demo mode</span>
        <span className="hidden sm:inline">·</span>
        <span className="hidden sm:inline">
          You&apos;re previewing TeachMeOnline.ca. Generated content is watermarked and certificates are not issued.
        </span>
      </div>
    </div>
  );
}
